import handlebars from "handlebars";

const eq = (a: any, b: any) => a === b;

// Register the 'eq' helper with Handlebars
handlebars.registerHelper("eq", eq);

const appraisalDetailsTemplate = `<!DOCTYPE html>
<html>
  <head>
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  </head>
  <body>
    <div id="print-AppraisalDtls">
      
    <hr id="print-AppraisalDtls-hr"></hr>
    <table id = "print-AppraisalDtls-table">
      <tr>
        <td><label class="print-AppraisalDtls-label">Investment :</label><br><input class="print-AppraisalDtls-input type="text" value="{{investmentName}}"></input></td>
        <td><label class="print-AppraisalDtls-label">Fund :</label><br><input class="print-AppraisalDtls-input type="text" class="Autopopulatefield"  value="{{fund}}"></input></td>
      </tr>
      <tr>
        <td><label class="print-AppraisalDtls-label">Asset&nbsp;Manager :</label><br><input class="print-AppraisalDtls-input type="text" class="Autopopulatefield" value="{{assetManager}}"></input></td>
        <td><label class="print-AppraisalDtls-label">City&nbsp;/&nbsp;State&nbsp;/&nbsp;Counrty :</label><br><input class="print-AppraisalDtls-input type="text" class="Autopopulatefield" value="{{cityStateCountry}}"></input></td>
      </tr>
      <tr>
        <td><label class="print-AppraisalDtls-label">Appraiser&nbsp;1 : &nbsp;&nbsp;  {{userType}} User</label><br><input class="print-AppraisalDtls-input type="text" value="{{appraiser1}}"></input></td>
        <td><label class="print-AppraisalDtls-label">Investment&nbsp;Type :</label><br><input class="print-AppraisalDtls-input type="text" class="Autopopulatefield" value="{{investmentType}}"></input></td>
      </tr>
      <tr>
        <td><label class="print-AppraisalDtls-label">Appraisal&nbsp;Firm  :</label><br><input class="print-AppraisalDtls-input type="text" value="{{appraisalFirm}}"></input></td>
        <td><label class="print-AppraisalDtls-label">External&nbsp;Appraiser&nbsp;Name :</label><br><input class="print-AppraisalDtls-input type="text" value="{{externalAppraiser}}"></input></td>
      </tr>
    </table>

    
    </div>
  </body>
</html>
`;
export default appraisalDetailsTemplate;


// <style>
//       body {
//         font-family: Roboto, Helvetica, Arial, sans-serif;
//       }
//       table {
//         width: 100%;
//         table-layout: fixed; /* Fix the table layout to ensure consistent column widths */
//       }

//         td {
//           padding: 10px; /* Adjust the padding to provide consistent spacing for labels and inputs */
//         }

//         label {
//           display: inline-block; /* Ensure each label is on its own line */
//           margin-bottom: 5px;
//           font-weight: bold;
//         }

      
//         input {
//         width: calc(100% - 20px); /* Calculate the width of the input to account for padding */
//         margin-bottom: 5px;
//         box-sizing: border-box; /* Include padding and border in the element's total width and height */
//         height: 30px; /* Set the desired height for the input */
//         font-size: 16px; /* Set the desired font size for the input */
//         border: 1px solid #263746; /* Set the border color and width */
//         border-radius: 5px; /* Add border radius to the input */
//         box-shadow: 1px 1px 1px #888888; /* Add a box shadow with horizontal offset, vertical offset, blur radius, and color */
//       }

//       .Autopopulatefield {
//         background-color: #eeeeee !important;
//       }

//       hr{
//         border: none; /* Remove the default border */
//         border-top: 2px solid #263746; /* Add a new solid border on the top */
//         margin: 0; /* Remove any default margin */
//         padding: 0; /* Remove any default padding */
//         height: 10px; /* Set the desired height for the border */
//         box-shadow: 1cm;
//       }
//     </style>